<template>
  <div class="grey lighten-5 h-100 d-flex align-start mt-8 justify-center">
    <div
      :class="
        $mq == 'miniMobilePhones'
          ? 'table-width-miniPhones'
          : isExtension
          ? 'table-width-extension d-flex justify-center align-center'
          : $vuetify.breakpoint.md
          ? 'table-width-2'
          : $vuetify.breakpoint.sm
          ? 'table-width-3'
          : $vuetify.breakpoint.xs
          ? 'table-width-miniPhones'
          : getSidebarMini
          ? 'table-width-4'
          : 'table-width'
      "
    >
      <v-data-table
        :class="[{ edited_scrollbar: isMac }]"
        :headers="headers"
        :items="filteredProjects"
        :items-per-page="-1"
        class="elevation-0 table-border"
        height="calc(100vh - 100px)"
        fixed-header
        :mobile-breakpoint="0"
        hide-default-footer
        :loading="loader"
        loading-text="No data available"
        :custom-sort="customSort"
      >
        <v-progress-linear
          slot="progress"
          color="#2a206a"
          class="px-2"
          indeterminate
        ></v-progress-linear>
        <!-- Column Search Row -->
        <template v-slot:[`body.prepend`]="{ headers }">
          <tr>
            <td v-for="(header, i) in headers" :key="i">
              <div v-if="header.value == 'project'" class="sub-header">
                <div class="inputContainer">
                  <v-icon small class="ml-1 mt-3"> mdi-magnify </v-icon>
                  <input
                    v-model="projectSearch"
                    autocomplete="off"
                    type="text"
                    size="15"
                    id="name-search"
                    class="header-search-input-field mb-1 mt-2 rounded-2 inp-width"
                    placeholder="Search..."
                  />
                </div>
              </div>
            </td>
          </tr>
        </template>
        <!-- Project Name Column -->
        <template v-slot:[`item.project`]="{ item }">
          <div>
            <div
              style="width: 200px"
              v-if="
                selectedProject ? selectedProject.id == item.id && editing : ''
              "
            >
              <v-text-field
                autofocus
                color="#DCD8F3"
                hide-details
                dense
                outlined
                v-model="selectedProject.name"
                @blur="updateProjectName(selectedProject)"
                @keydown.enter="updateProjectName(selectedProject)"
              >
                <template slot="append">
                  <v-icon
                    @click="updateProjectName(selectedProject)"
                    small
                    class="mt-1"
                    color="#2a206a"
                    >mdi-check</v-icon
                  >
                </template>
              </v-text-field>
            </div>
            <div
              v-else
              @click="
                (selectedProject = item), (editing = true), (title = item.name)
              "
            >
              <span
                style="max-width: 20vw"
                class="text-capitalize body-2 dark-purple-text text-truncate font-weight-bold pointer"
              >
                {{ item.name ? item.name : "No Name" }}
              </span>
            </div>
          </div>
        </template>
        <!-- Members Column -->
        <template v-slot:[`item.members`]="{ item }">
          <!-- <template v-slot:activator="{ on, attrs }"> -->
          <div
            id="openProjectAssociatedMemberDropdown"
            class="pointer"
            style="max-width: 300px"
            @click="
              (teamLeads = getProjectTeamManagers(item)),
                (selectedProjectItem = item),
                (memberSearch = null),
                (selectedItem = null);
              openMemberMenu($event);
            "
          >
            <div
              class="d-flex align-center"
              v-if="
                (selectedProjectItem && selectedProjectItem.id == item.id) ||
                getProjectAssignees(item.id).length
              "
            >
              <div
                class="d-flex align-center"
                v-if="!selectedProjectItem || selectedProjectItem.id != item.id"
              >
                <ProfileImage
                  v-show="
                    getProjectAssignees(item.id)[0].image ? ':src' : ':username'
                  "
                  :src="getProjectAssignees(item.id)[0].image"
                  inline
                  :username="
                    getProjectAssignees(item.id)[0].name
                      ? getProjectAssignees(item.id)[0].name
                      : getProjectAssignees(item.id)[0].email
                  "
                  :size="28"
                  :userProfile="true"
                  :circular="true"
                  class="mr-3 text-light"
                >
                </ProfileImage>
                <ProfileImage
                  v-if="item.project_members_count > 1"
                  inline
                  :username="`+${item.project_members_count - 1}`"
                  :size="28"
                  :userProfile="true"
                  :circular="true"
                  class="text-light d-inline ml-n8 mr-2"
                >
                </ProfileImage>
                <span
                  style="max-width: 290px"
                  class="text-capitalize text-truncate dark-purple-text"
                  >{{
                    getProjectAssignees(item.id)[0].name
                      ? getProjectAssignees(item.id)[0].name
                      : getProjectAssignees(item.id)[0].email
                  }}</span
                >
              </div>
              <div
                class="d-flex align-center"
                v-if="selectedProjectItem && selectedProjectItem.id == item.id"
              >
                <div class="d-flex align-center" v-if="projectAssignees.length">
                  <ProfileImage
                    v-show="projectAssignees[0].image ? ':src' : ':username'"
                    :src="projectAssignees[0].image"
                    inline
                    :username="
                      projectAssignees[0].name
                        ? projectAssignees[0].name
                        : projectAssignees[0].email
                    "
                    :size="28"
                    :userProfile="true"
                    :circular="true"
                    class="mr-3 text-light"
                  >
                  </ProfileImage>
                  <ProfileImage
                    v-if="projectAssignees.length > 1"
                    inline
                    :username="`+${projectAssignees.length - 1}`"
                    :size="28"
                    :userProfile="true"
                    :circular="true"
                    class="text-light d-inline ml-n8 mr-2"
                  >
                  </ProfileImage>
                  <span
                    style="max-width: 500px"
                    class="text-capitalize text-truncate dark-purple-text"
                    >{{
                      projectAssignees[0].name
                        ? projectAssignees[0].name
                        : projectAssignees[0].email
                    }}</span
                  >
                </div>
                <!-- If no members -->
                <div
                  v-else
                  @click="(selectedProjectItem = item), (memberSearch = null)"
                  class="pointer"
                >
                  <div class="d-flex text-truncate align-center pointer">
                    <span
                      class="empty-avatar mr-3 pointer caption--text d-inline-block d-flex align-center justify-center"
                      ><v-icon color="#757096" x-small>mdi-plus</v-icon></span
                    >
                    <span class="dusty-purple-text caption">Add Member</span>
                  </div>
                </div>
              </div>
            </div>
            <!-- If no members -->
            <div
              v-else
              @click="(selectedProjectItem = item), (memberSearch = null)"
              class="pointer"
            >
              <div class="d-flex text-truncate align-center pointer">
                <span
                  class="empty-avatar mr-3 pointer caption--text d-inline-block d-flex align-center justify-center"
                  ><v-icon color="#757096" x-small>mdi-plus</v-icon></span
                >
                <span class="dusty-purple-text caption">Add Member</span>
              </div>
            </div>
          </div>
          <!-- </v-btn> -->
          <!-- </template> -->
        </template>
        <!-- Members Count -->
        <template v-slot:[`item.total_members`]="{ item }">
          <v-tooltip content-class="arrow-up" color="#DCD8F3" bottom>
            <template v-slot:activator="{ on, attrs }">
              <v-chip
                v-on="on"
                v-bind="attrs"
                @click="
                  (selectedProjectItem = item),
                    (openMembersDialog = true),
                    (teamLeads = getProjectTeamManagers(item))
                "
                small
                class="green-chip-color ml-5 pointer"
                label
              >
                <span class="font-weight-bold">{{
                  selectedProjectItem
                    ? selectedProjectItem.id == item.id && projectAssignees
                      ? projectAssignees.length
                      : item.project_members_count
                    : item.project_members_count
                }}</span>
              </v-chip>
            </template>
            <span class="font-weight-bold dark-purple-text">View Members</span>
          </v-tooltip></template
        >
        <!-- Team Lead Column -->
        <template v-slot:[`item.team_manager`]="{ item }">
          <div id="openTeamLeadDropdown">
            <!-- <template v-slot:activator="{ on, attrs }"> -->
            <span
              class="pointer"
              @click="
                (teamLeads = getProjectTeamManagers(item)),
                  (selectedProjectItem = item),
                  (memberSearch = null),
                  (selectedItem = null),
                  openLeadMenu($event)
              "
            >
              <span
                v-if="
                  getProjectTeamManagers(item).length ||
                  (selectedProjectItem && teamLeads.length)
                "
              >
                <span
                  v-for="(lead, index) in selectedProjectItem &&
                  selectedProjectItem.id == item.id
                    ? teamLeads
                    : getProjectTeamManagers(item)"
                  :key="index"
                >
                  <!-- for xs-screens, sm-screens & md-screens -->
                  <v-chip
                    v-if="
                      index < 1 &&
                      ($vuetify.breakpoint.xs ||
                        $vuetify.breakpoint.sm ||
                        $vuetify.breakpoint.md)
                    "
                    class="text-capitalize blue-chip-color mr-1 mt-1"
                    small
                  >
                    <span class="text-truncate" style="max-width: 120px">{{
                      lead.name ? lead.name : lead.email
                    }}</span>
                  </v-chip>
                  <!-- for lg-screens -->
                  <v-chip
                    v-if="index < 3 && $vuetify.breakpoint.lg"
                    class="text-capitalize blue-chip-color mr-1 mt-1"
                    small
                  >
                    <span class="text-truncate" style="max-width: 120px">{{
                      lead.name ? lead.name : lead.email
                    }}</span>
                  </v-chip>
                  <!-- for xl-screens -->
                  <v-chip
                    v-if="index < 6 && $vuetify.breakpoint.xl"
                    class="text-capitalize blue-chip-color mr-1 mt-1"
                    small
                  >
                    <span class="text-truncate" style="max-width: 120px">{{
                      lead.name ? lead.name : lead.email
                    }}</span>
                  </v-chip>
                </span>
                <!-- for xs-screens, sm-screens & md-screens -->
                <sub
                  class="grey--text caption--text"
                  v-if="
                    (selectedProjectItem
                      ? selectedProjectItem.id == item.id
                        ? teamLeads.length > 1
                        : getProjectTeamManagers(item).length > 1
                      : getProjectTeamManagers(item).length > 1) &&
                    ($vuetify.breakpoint.xs ||
                      $vuetify.breakpoint.sm ||
                      $vuetify.breakpoint.md)
                  "
                >
                  +
                  {{
                    selectedProjectItem
                      ? selectedProjectItem.id == item.id
                        ? teamLeads && teamLeads.length > 1
                        : getProjectTeamManagers(item).length - 1
                      : getProjectTeamManagers(item).length - 1
                  }}
                  more
                </sub>
                <!-- for lg-screens -->
                <sub
                  class="grey--text caption--text"
                  v-if="
                    (selectedProjectItem
                      ? selectedProjectItem.id == item.id
                        ? teamLeads && teamLeads.length > 3
                        : getProjectTeamManagers(item).length > 3
                      : getProjectTeamManagers(item).length > 3) &&
                    $vuetify.breakpoint.lg
                  "
                >
                  +
                  {{
                    selectedProjectItem
                      ? selectedProjectItem.id == item.id
                        ? teamLeads.length
                          ? teamLeads.length - 3
                          : ""
                        : getProjectTeamManagers(item).length - 3
                      : getProjectTeamManagers(item).length - 3
                  }}
                  more
                </sub>
                <!-- for xl-screens -->
                <sub
                  class="green--text caption--text"
                  v-if="
                    (selectedProjectItem &&
                    selectedProjectItem.id == item.id &&
                    teamLeads
                      ? teamLeads.length > 6
                      : getProjectTeamManagers(item).length > 6) &&
                    $vuetify.breakpoint.xl
                  "
                >
                  +
                  {{
                    selectedProjectItem &&
                    selectedProjectItem.id == item.id &&
                    teamLeads
                      ? teamLeads.length - 6
                      : getProjectTeamManagers(item).length - 6
                  }}
                  more
                </sub>
              </span>
              <!-- If No team lead -->
              <!-- selected {{ selectedProjectItem ? selectedProjectItem.name : "" }} -->
              <v-chip
                small
                v-if="
                  selectedProjectItem
                    ? selectedProjectItem.id == item.id
                      ? !teamLeads.length
                      : !getProjectTeamManagers(item).length
                    : !getProjectTeamManagers(item).length
                "
                class="text-capitalize grey-chip-color mr-1 my-1"
                >None</v-chip
              >
            </span>
            <!-- </template> -->
          </div>
        </template>
      </v-data-table>
    </div>
    <!-- Member menu -->
    <v-menu
      absolute
      min-width="300"
      content-class="bg-white dropdown"
      :close-on-content-click="false"
      nudge-left="50"
      nudge-bottom="10"
      :position-x="x"
      :position-y="y"
      offset-y
      v-model="openMemberDropdown"
      @blur="selectedProjectItem = null"
    >
      <!-- Member search-->
      <div :class="[{ edited_scrollbar: isMac }]">
        <!-- Search field -->
        <div class="search-border rounded ma-2">
          <v-text-field
            prepend-inner-icon="mdi-magnify"
            background-color="white"
            placeholder="Search..."
            class="body-2"
            color="#757096"
            hide-details
            solo
            flat
            dense
            autofocus
            v-model="memberSearch"
            autocomplete="off"
            @keydown.up="selectPrev"
            @keydown.down="selectNext"
            @keydown.enter="
              selectedItem != null
                ? addOrRemoveMember(filteredAllProjectMembers[selectedItem])
                : ''
            "
          >
          </v-text-field>
        </div>
        <v-list
          v-if="selectedProjectItem"
          class="pointer overflow-scroll"
          scrollable
          max-height="170"
        >
          <div
            v-for="(member, index) in filteredAllProjectMembers"
            :key="member.email"
            :disabled="
              member.id == getLoggedInUser.id ||
              selectedProjectItem.project_members.length <= 1
                ? true
                : false
            "
            @click="addOrRemoveMember(member)"
            class="d-flex listing-hover caption list-item-min-height"
            :class="
              selectedItem == index
                ? 'hovered'
                : projectAssignees.find((item) => {
                    return item.id == member.id;
                  })
                ? 'bg-selected white-border-bottom'
                : ''
            "
          >
            <ProfileImage
              v-show="member.image ? ':src' : ':username'"
              :src="member.image"
              inline
              :username="member.name ? member.name : member.email"
              :size="23"
              :userProfile="true"
              :circular="true"
              class="ml-3 text-light"
            >
            </ProfileImage>
            <v-list-item-content
              style="max-width: 160px"
              class="d-inline-block text-truncate ml-3"
              v-if="member.name"
              >{{
                getLoggedInUser.id == member.id
                  ? "ME"
                  : member.name[0].toUpperCase() +
                    member.name.slice(1).toLowerCase()
              }}</v-list-item-content
            >
            <v-list-item-content
              style="max-width: 160px"
              class="d-inline-block text-truncate ml-3"
              v-if="!member.name"
              >{{ member.email }}</v-list-item-content
            >
            <v-spacer></v-spacer>
            <v-icon
              v-show="
                projectAssignees.find((item) => {
                  return item.id == member.id;
                })
              "
              small
              class="mr-4"
              color="#1cc283"
              >mdi-check-box-outline</v-icon
            >
          </div>
          <div
            v-if="
              memberSearch &&
              !filteredProjectAssignees(selectedProjectItem.id).length &&
              !filteredProjectNonAssignees(selectedProjectItem.id).length
            "
          >
            <p class="no-results-found my-1">No results found</p>
          </div>
        </v-list>
      </div>
    </v-menu>
    <!-- Team Lead menu -->
    <v-menu
      absolute
      min-width="300"
      content-class="bg-white dropdown"
      :close-on-content-click="false"
      nudge-left="50"
      nudge-bottom="10"
      :position-x="x"
      :position-y="y"
      offset-y
      v-model="openLeadDropdown"
    >
      <!-- Team Manager search-->
      <div :class="[{ edited_scrollbar: isMac }]">
        <!-- Search field -->
        <div class="search-border rounded ma-2">
          <v-text-field
            prepend-inner-icon="mdi-magnify"
            background-color="white"
            placeholder="Search..."
            class="body-2"
            color="#757096"
            hide-details
            solo
            flat
            dense
            autofocus
            v-model="teamManagerSearch"
            autocomplete="off"
            @keydown.up="selectPrev2"
            @keydown.down="selectNext2"
            @keydown.enter="
              selectedItem != null
                ? addOrRemoveTeamManager(teamManagerList[selectedItem])
                : ''
            "
          >
          </v-text-field>
        </div>
        <v-list
          v-if="selectedProjectItem"
          class="pointer overflow-scroll"
          scrollable
          max-height="170"
        >
          <div
            v-for="(member, index) in teamManagerList"
            :key="member.email"
            :disabled="
              member.id == getLoggedInUser.id ||
              selectedProjectItem.project_members.length <= 1
                ? true
                : false
            "
            @click="addOrRemoveTeamManager(member)"
            class="d-flex listing-hover caption list-item-min-height"
            :class="
              selectedItem == index
                ? 'hovered'
                : teamLeads.find((item) => {
                    return item.id == member.id;
                  })
                ? 'bg-selected white-border-bottom'
                : ''
            "
          >
            <ProfileImage
              v-show="member.image ? ':src' : ':username'"
              :src="member.image"
              inline
              :username="member.name ? member.name : member.email"
              :size="23"
              :userProfile="true"
              :circular="true"
              class="ml-3 text-light"
            >
            </ProfileImage>
            <v-list-item-content
              style="max-width: 160px"
              class="d-inline-block text-truncate ml-3"
              v-if="member.name"
              >{{
                getLoggedInUser.id == member.id
                  ? "ME"
                  : member.name[0].toUpperCase() +
                    member.name.slice(1).toLowerCase()
              }}</v-list-item-content
            >
            <v-list-item-content
              style="max-width: 160px"
              class="d-inline-block text-truncate ml-3"
              v-if="!member.name"
              >{{ member.email }}</v-list-item-content
            >
            <v-spacer></v-spacer>
            <v-icon
              v-show="
                teamLeads.find((item) => {
                  return item.id == member.id;
                })
              "
              small
              class="mr-4"
              color="#1cc283"
              >mdi-check-box-outline</v-icon
            >
          </div>
          <div v-if="teamManagerSearch && !teamManagerList.length">
            <p class="no-results-found my-1">No results found</p>
          </div>
        </v-list>
      </div>
    </v-menu>
    <SnackbarNew
      :snackbar.sync="snackbar"
      :snackbarError="snackbarError"
      :snackbarMessage="snackbarMessage"
    />
    <template v-if="openMembersDialog">
      <ProjectMembersDialog
        :selectedProject="selectedProjectItem"
        :openMembersDialog.sync="openMembersDialog"
      />
    </template>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import { snackbarMixin } from "@/mixins/snackbarMixin";
import { projectsCRUD } from "@/mixins/projectsCRUD";

export default {
  name: "ProjectList",
  components: {
    ProfileImage: () => import("@/components/Includes/ProfileImage"),
    SnackbarNew: () => import("@/components/Includes/SnackbarNew"),
    ProjectMembersDialog: () =>
      import("@/components/Projects/ProjectMembersDialog"),
  },
  mixins: [projectsCRUD, snackbarMixin],
  props: ["open", "extension"],
  data() {
    return {
      projectSearch: null,
      x: null, // Mouse position
      y: null, // Mouse position
      openMemberDropdown: false,
      openLeadDropdown: false,
      openMembersDialog: false,
      title: null,
      editing: false,
      dialog: false,
      memberSearch: null,
      teamManagerSearch: null,
      projectAssignees: [],
      projectNonAssignees: [],
      teamLeads: [],
      selectedProject: null,
      loader: false,
      selectedProjectItem: null,
      sortDesc: false,
      headers: [
        {
          text: "Project",
          align: "start",
          value: "project",
          class: "table-header-bg dark-purple-text px-3",
          // width: "30vw",
          sortable: true,
        },
        {
          text: "Members",
          value: "members",
          class: "table-header-bg dark-purple-text px-3",
          align: "start",
          // width: "10vw",
          sortable: false,
        },
        {
          text: "Total Members",
          value: "total_members",
          class: "table-header-bg dark-purple-text px-3",
          align: "start",
          sortable: false,
          width: "180px",
        },
        {
          text: "Team Manager",
          value: "team_manager",
          class: "table-header-bg dark-purple-text px-3",
          align: "start",
          // width: "20vw",
          sortable: false,
        },
      ],
      selectedItem: null,
      inPendingState: false,
    };
  },
  computed: {
    ...mapGetters([
      "getSelectedCompany",
      "getCompanyMembers",
      "getActiveTask",
      "getSelectedProject",
      "getLoggedInUser",
      "getProjects",
      "getOnlineStatus",
      "getSidebarMini",
      "getAllMembers",
      "getProjectAssignees",
      "getProjectNonAssignees",
    ]),
    filteredProjects() {
      // Search query on 'name;
      return this.projectSearch
        ? this.getProjects.filter((item) => {
            return item.name &&
              item.name.toLowerCase().includes(this.projectSearch.toLowerCase())
              ? true
              : false;
          })
        : this.getProjects;
    },
    filteredAllProjectMembers() {
      return this.filteredProjectAssignees(this.selectedProjectItem.id) &&
        this.filteredProjectNonAssignees(this.selectedProjectItem.id)
        ? this.filteredProjectAssignees(this.selectedProjectItem.id).concat(
            this.filteredProjectNonAssignees(this.selectedProjectItem.id)
          )
        : [];
    },
    nonTeamLeads() {
      if (this.selectedProjectItem) {
        let allMembers =
          this.filteredProjectAssignees(this.selectedProjectItem.id) &&
          this.filteredProjectNonAssignees(this.selectedProjectItem.id)
            ? this.filteredProjectAssignees(this.selectedProjectItem.id).concat(
                this.filteredProjectNonAssignees(this.selectedProjectItem.id)
              )
            : [];
        return allMembers && this.selectedProjectItem
          ? allMembers.filter(
              (item) => !this.teamLeads.map((user) => user.id).includes(item.id)
            )
          : [];
      } else return [];
    },
    // filteredLeads() {},
    teamManagerList() {
      return this.teamLeads && this.teamManagerSearch
        ? this.teamLeads.concat(this.nonTeamLeads).filter((item) => {
            return item.name
              ? item.name
                  .toLowerCase()
                  .includes(this.teamManagerSearch.toLowerCase())
              : item.email
                  .toLowerCase()
                  .includes(this.teamManagerSearch.toLowerCase());
          })
        : this.teamLeads.concat(this.nonTeamLeads);
    },
  },
  watch: {
    selectedProjectItem(value) {
      // updates projectAssignees array @change in selectedProjectItem
      value
        ? ((this.projectAssignees = this.filteredProjectAssignees(
            this.selectedProjectItem.id
          )),
          (this.projectTeamManagers = this.getTeamLeadMembers))
        : () => {};
    },
  },
  methods: {
    openMemberMenu(event) {
      event.stopPropagation();
      this.x = event.clientX;
      this.y = event.clientY;
      this.openMemberDropdown = true;
    },
    openLeadMenu(event) {
      event.stopPropagation();
      this.x = event.clientX;
      this.y = event.clientY;
      (this.teamManagerSearch = null), (this.openLeadDropdown = true);
    },
    customSort: function (items, index, isDesc) {
      items.sort((a, b) =>
        a.name.toLowerCase() > b.name.toLowerCase() ? 1 : -1
      );
      return items;
    },
    selectPrev() {
      if (this.selectedItem != null && this.filteredAllProjectMembers) {
        if (this.selectedItem <= 0) {
          this.selectedItem = this.filteredAllProjectMembers.length - 1;
        } else {
          this.selectedItem -= 1;
        }
      } else {
        this.selectedItem = 0;
      }
    },
    selectNext() {
      if (this.selectedItem != null && this.filteredAllProjectMembers) {
        if (this.selectedItem >= this.filteredAllProjectMembers.length - 1) {
          this.selectedItem = 0;
        } else {
          this.selectedItem += 1;
        }
      } else {
        this.selectedItem = 0;
      }
    },
    selectPrev2() {
      if (this.selectedItem != null && this.teamManagerList) {
        if (this.selectedItem <= 0) {
          this.selectedItem = this.teamManagerList.length - 1;
        } else {
          this.selectedItem -= 1;
        }
      } else {
        this.selectedItem = 0;
      }
    },
    selectNext2() {
      if (this.selectedItem != null && this.teamManagerList) {
        if (this.selectedItem >= this.teamManagerList.length - 1) {
          this.selectedItem = 0;
        } else {
          this.selectedItem += 1;
        }
      } else {
        this.selectedItem = 0;
      }
    },
    // Select task for editing title
    selectTitle(title) {
      this.title = title;
    },
    // To Edit Project Name
    updateProjectName(selectedProject) {
      let payload = {
        company_id: this.getSelectedCompany.id,
        name: this.selectedProject.name,
        project_id: selectedProject.id,
      };
      this.$store
        .dispatch("updateProject", payload)
        .then(() => {
          this.editing = false;
          this.openSnackbar(false, "Project name updated");
        })
        .catch((error) => {
          this.editing = false;
          this.selectedProject.name = this.title;
          let nameErrors = error.response.data.errors.name;
          nameErrors.forEach((error) => {
            this.openSnackbar(true, error);
          });
        });
    },
    // To Display Project Members on component render
    getProjectMembers(item) {
      let membersArray = item.project_members;
      let project_members = [];
      this.getCompanyMembers.forEach((member) => {
        if (membersArray && membersArray.includes(member.id)) {
          project_members.push(member);
        }
      });
      return project_members;
    },
    // To Display Project Members on component render
    getProjectTeamManagers(item) {
      let membersArray = item.project_leads;
      let team_managers = [];
      this.getProjectMembers(item).forEach((member) => {
        if (membersArray && membersArray.includes(member.id)) {
          team_managers.push(member);
        }
      });
      return team_managers;
    },
    // for member search 1
    filteredProjectAssignees(id) {
      return this.getProjectAssignees(id)
        ? this.memberSearch
          ? this.getProjectAssignees(id).filter((item) => {
              return item.name
                ? item.name
                    .toLowerCase()
                    .includes(this.memberSearch.toLowerCase())
                : item.email
                    .toLowerCase()
                    .includes(this.memberSearch.toLowerCase());
            })
          : this.getProjectAssignees(id)
        : [];
    },
    // for member search 2
    filteredProjectNonAssignees(id) {
      return this.getProjectNonAssignees(id)
        ? this.memberSearch
          ? this.getProjectNonAssignees(id).filter((item) => {
              return item.name
                ? item.name
                    .toLowerCase()
                    .includes(this.memberSearch.toLowerCase())
                : item.email
                    .toLowerCase()
                    .includes(this.memberSearch.toLowerCase());
            })
          : this.getProjectNonAssignees(id)
        : [];
    },
    // To add or remove a member from project
    addOrRemoveMember(member) {
      let status = this.projectAssignees.find((item) => {
        return item.id == member.id;
      });
      // Going To Add
      if (!status) {
        this.projectAssignees.push(member);
        this.$store
          .dispatch("assignProjectMembers", {
            company_id: this.getSelectedCompany.id,
            project_id: this.selectedProjectItem.id,
            add_member: member.id,
          })
          .then(() => {
            this.loader = false;
            this.openSnackbar(false, "Member Added!");
            this.$store.dispatch("fetchTeamMembers");
          })
          .catch((error) => {
            this.loader = false;
            this.openSnackbar(true, error.error_message);
          })
          .finally(() => {
            this.$store.dispatch("fetchProjects");
          });
      }
      // Going To Remove
      if (status) {
        // for reactive front-end
        this.projectAssignees = this.projectAssignees.filter((item) => {
          return item.id != member.id;
        });

        this.$store
          .dispatch("assignProjectMembers", {
            company_id: this.getSelectedCompany.id,
            project_id: this.selectedProjectItem.id,
            remove_member: member.id,
          })
          .then(() => {
            this.loader = false;
            this.openSnackbar(false, "Member Successfully Removed!");
            this.$store.dispatch("fetchTeamMembers");
          })
          .catch((error) => {
            this.projectAssignees.unshift(member);
            this.loader = false;
            this.openSnackbar(true, error.response.data.error_msg);
          })
          .finally(() => {
            this.$store.dispatch("fetchProjects");
          });
      }
    },
    addOrRemoveTeamManager(member) {
      this.inPendingState = true;
      let status = this.teamLeads.find((item) => {
        return item.id == member.id;
      });
      //going to add team-manager
      if (!status) {
        this.projectAssignees.push(member);
        this.teamLeads.push(member);
        this.$store
          .dispatch("assignTeamManager", {
            company_id: this.getSelectedCompany.id,
            project_id: this.selectedProjectItem.id,
            member_id: member.id,
            project_lead: true,
          })
          .then((res) => {
            this.loader = false;
            this.openSnackbar(false, res.data.error_msg);
            this.inPendingState = false;
          })
          .catch((error) => {
            this.loader = false;
            this.openSnackbar(true, error.error_message);
            this.inPendingState = false;
          })
          .finally(() => {
            this.$store.dispatch("fetchProjects");
          });
      }
      // going to remove
      if (status) {
        this.teamLeads = this.teamLeads.filter((item) => {
          return item.id != member.id;
        });
        this.projectAssignees = this.projectAssignees.filter((item) => {
          return item.id != member.id;
        });
        this.$store
          .dispatch("assignTeamManager", {
            company_id: this.getSelectedCompany.id,
            project_id: this.selectedProjectItem.id,
            member_id: member.id,
            project_lead: false,
          })
          .then((res) => {
            this.loader = false;
            this.openSnackbar(false, res.data.error_msg);
            this.inPendingState = false;
          })
          .catch((error) => {
            this.loader = false;
            this.openSnackbar(true, error.error_message);
            this.inPendingState = false;
          })
          .finally(() => {
            this.$store.dispatch("fetchProjects");
          });
      }
    },
    // rowClick(item) {
    //     this.selectedProjectItem = item;
    //     this.teamLeads = this.getProjectTeamManagers(item);
    // },
  },
  mounted() {
    this.loader = true;
    this.$store.dispatch("fetchProjects").then(() => {
      return (this.loader = false);
    });
  },
};
</script>
<style scoped>
.empty-avatar {
  height: 30px;
  width: 30px;
  background-color: #edebf9;
  border-radius: 60%;
  border: 1px dashed #757096;
  /* display: inline-block; */
}
.font-size {
  font-size: 10px;
}
.listing-hover:hover {
  color: #1cc283 !important;
  background: #e9fcf5 !important;
}

.w-12 {
  width: 120px !important;
}
.task-bar-btns {
  background-color: transparent !important;
  color: #1cc283;
}
.task-bar-btns-borders {
  border: 1px #2b6ad8 solid;
  color: #2b6ad8;
  border-radius: 20px;
  background-color: #e5efff !important;
}
.task-bar-btns-height {
  height: 30px !important;
}
.hovered {
  background-color: #e5efff !important;
}
.bg-color {
  background-color: white !important;
}
/* works in combination with global 'dropdown' class */
.dropdown-left::before {
  position: absolute;
  content: "";
  top: 0px;
  left: 55%;
  /* left: 20px; */
  transform: translateY(-100%);
  width: 10px;
  height: 13px;
  border-left: 10px solid transparent;
  border-right: 10px solid transparent;
  border-bottom: 13px solid #fff;
}
.white-border-bottom {
  border-bottom: 1px solid white;
}
.hovered {
  background-color: #aeefd6 !important;
}
.inputContainer i {
  position: absolute;
}
.v-progress-linear {
  background: transparent;
  overflow: hidden;
  position: initial;
  transition: 0.2s cubic-bezier(0.4, 0, 0.6, 1);
  width: 100%;
}
/* .task-table tbody tr:nth-of-type(even) {
  background-color: rgba(78, 78, 78, 0.05);
} */
</style>